import MobilePopupHandler from '@scripts/modules/MobileMenu'

new MobilePopupHandler({
   selector: '.mobile-menu',
   elClose: '.mobile-menu .menu-close',
   elOpen: '.ui-burger',
   overlay: '.ui-overlay.basic'
})